import { formatNumberLocaleRaw } from '@/shared/utils/locale_number_utils.js';

export function formatearNumero(valor, decimales = 2) {
  if (valor === null || valor === undefined || valor === '') return '--';

  const numero = Number(valor);
  if (isNaN(numero)) return '--';

  const precision = Math.min(20, Math.max(0, Math.trunc(Number(decimales) || 2)));

  if (numero === 0) return formatNumberLocaleRaw(0, precision);

  const absNumero = Math.abs(numero);

  if (absNumero > 0 && absNumero < 0.0001) {
    const decimalesValorPequenio = (absNumero.toFixed(20).split('.')[1] || '').search(/[1-9]/) + 1;

    if (decimalesValorPequenio > 0) {
      return formatNumberLocaleRaw(numero, Math.max(precision, decimalesValorPequenio));
    }
  }

  const rounded =
    precision === 0
      ? Math.round(numero)
      : Number(`${Math.round(Number(`${numero}e${precision}`))}e-${precision}`);

  return formatNumberLocaleRaw(rounded, precision);
}

export function formatearPorcentaje(valor, decimales = 2) {
  if (valor === null || valor === undefined || valor === '') return '--';

  const numero = Number(valor);
  if (isNaN(numero)) return '--';

  const porcentaje = numero * 100;
  return `${formatearNumero(porcentaje, decimales)}%`;
}

export function formatearUnidad(valor, unidad, decimales = 2) {
  const numeroFormateado = formatearNumero(valor, decimales);
  if (numeroFormateado === '--') return '--';

  const unidadMap = {
    m: 'm',
    metros: 'm',
    metrosLineales: 'm',
    m2: 'm²',
    metrosCuadrados: 'm²',
    kg: 'kg',
    kilogramos: 'kg',
    'g/m2': 'g/m²',
    gramaje: 'g/m²',
    u: 'u',
    unidades: 'u',
    pliegos: 'pliegos',
    mm: 'mm',
    micras: 'µm',
    'g/cm3': 'g/cm³',
  };

  const unidadFormateada = unidadMap[unidad] || unidad || '';
  return unidadFormateada ? `${numeroFormateado} ${unidadFormateada}` : numeroFormateado;
}

export function unidadVelocidad(unidadTrabajo) {
  if (!unidadTrabajo?.abreviaturaUnidadCantidad || !unidadTrabajo?.abreviaturaUnidadTiempo) {
    return 'm/min';
  }
  return `${unidadTrabajo.abreviaturaUnidadCantidad}/${unidadTrabajo.abreviaturaUnidadTiempo}`;
}

export function obtenerColorMerma(porcentaje) {
  if (porcentaje === null || porcentaje === undefined) return 'neutral';

  const porcentajeValor = Number(porcentaje) * 100;

  if (porcentajeValor < 5) return 'success';
  if (porcentajeValor <= 10) return 'warning';
  return 'error';
}

export function displayValue(valor, isStale, decimales = 2) {
  if (isStale) return '--';
  return formatearNumero(valor, decimales);
}

export function displayValueConUnidad(valor, unidad, isStale, decimales = 2) {
  if (isStale) return '--';
  return formatearUnidad(valor, unidad, decimales);
}

export function displayPorcentaje(valor, isStale, decimales = 2) {
  if (isStale) return '--';
  return formatearPorcentaje(valor, decimales);
}

export function formatearFecha(fechaIso) {
  if (!fechaIso) return '--';

  try {
    const fecha = new Date(fechaIso);
    if (isNaN(fecha.getTime())) return '--';

    const dia = String(fecha.getDate()).padStart(2, '0');
    const mes = String(fecha.getMonth() + 1).padStart(2, '0');
    const anio = fecha.getFullYear();
    const horas = String(fecha.getHours()).padStart(2, '0');
    const minutos = String(fecha.getMinutes()).padStart(2, '0');

    return `${dia}/${mes}/${anio} ${horas}:${minutos}`;
  } catch (error) {
    return '--';
  }
}
